import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import cursorBtn from '../img/cursor.svg'
import { kebabCase } from 'lodash'
import { Seo } from '../components/seo'
import styled from 'styled-components'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'
import { StaticImage, GatsbyImage, getImage } from 'gatsby-plugin-image'
import BackBtn from '../components/common/BackButton'
import { Lightbox } from 'react-modal-image'
// import Fade from 'react-reveal/fade'
// import Share from '../components/Share'
// import { Location } from '@reach/router'
import CopyToClipboard from '../components/CopyToClipboard'
// import BlogRollRecommended from '../components/BlogRollRecommended'
import FadeIn from '../components/FadeIn'

const BlogPostTemplate = ({
  content,
  contentComponent,
  image,
  externalImg,
  externalReportImages,
  images,
  description,
  tags,
  title
}) => {
  const PostContent = contentComponent || Content

  const [showImageIndex, setShowImageIndex] = useState(false)

  let pics
  if(images && images.length) {
    pics = images.map(l => l.img)
  }

  // console.log(externalReportImages)

  const newsImage = getImage(image)
  const articleRef = useRef()
  const [progress, setProgress] = useState(0)

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!articleRef.current) return;
  
      const { height } = articleRef.current.getBoundingClientRect();
      setProgress(window.scrollY / (height - window.innerHeight));
    };
  
    updateHeight();
  
    window.addEventListener("scroll", updateHeight);
    return () => {
      window.removeEventListener("scroll", updateHeight);
    };
  }, []);

  // console.log(progress)

  // ANALYTICS START
  useEffect(() => {
    setTimeout(function () {
      let isMobile = false
      let country = ''
      let city = ''

      if (window.innerWidth < 1100) {
        isMobile = true
      } else {
        isMobile = false
      }

      // console.log(process.env.NODE_ENV === 'development')

      if (process.env.NODE_ENV !== 'development') {
        try {
          fetch(`https://api.ipregistry.co/?key=${process.env.GATSBY_IP_REGISTRY_KEY}`)
            .then((res) => {
              return res.json()
              // console.log(res.json())
            }).then((payload) => {
              // console.log(payload.location.country.name + ', ' + payload.location.city)
              country = payload.location.country.name
              city = payload.location.city
            }).then(() => {
              if(city !== 'Mountain View')
              axios.post('/.netlify/functions/analytics', {
                isMobile,
                country,
                city
              }).then((response) => {
                // console.log('success', response)
                return {
                  statusCode: 200,
                  body: JSON.stringify(response)
                }
              }).catch((error) => {
                // console.log('error', error)
                return {
                  statusCode: 400,
                  body: JSON.stringify(error)
                }
              })
            })
        } catch (error) {
          console.log(error)
        }
      }
    }, 2500)
  }, [])
  // END ANALYTICS

  return (
    <>
    <section id='news' ref={articleRef} className='section' style={{ background: 'var(--color-background)', transition: '2.5s', display: 'relative' }}>
      <BackBtn />
        <div style={{ position: 'relative', height: '10vh' }}>
          <StaticImage
            src='../img/bg.svg'
            alt='Background'
            placeholder='blurred'
            // layout='constrained'
            loading='eager'
            // objectPosition='0% 10%'
            // backgroundColor='#000'
            // imgStyle={{ backgroundPosition: 'left' }}
            imgStyle={{
              width: '100%',
              height: '100%',
              // minHeight: '100vh',
              position: 'fixed',
              // backgroundPosition: 'left',
              backgroundRepeat: 'no-repeat',
              // filter: 'brightness(40%)'
            }}
          />
        </div>
        <FadeIn delay={100} duration={850}>
          <div className='container content'>
            <div className='columns is-multiline is-centered'>
              <div className='column is-1' />
              
              {/* <GatsbyImage
                image={externalReportImages.childImageSharp.gatsbyImageData}
                alt='Picture'
                loading='eager'
              /> */}

              <div className='column is-10' style={{ marginTop: '3.5rem' }}>
                <h1
                  className='title is-size-3-widescreen is-size-4-mobile has-hyphens has-text-weight-bold is-bold-light has-text-primary has-text-left'
                >
                  {title}
                </h1>

              <div className={`${pics && pics.length > 0 ? "" : "is-vcentered"} columns is-multiline`}>
                <div className='column is-6'>
                  <div style={{ maxWidth: '300px', marginTop: '1.5rem', marginBottom: '2rem' }}>
                    {image && externalImg ?
                      <GatsbyImage
                        image={newsImage}
                        alt='Picture'
                        loading='eager'
                      />
                      : null}

                    {externalImg && !image ? 
                      <GatsbyImage
                      image={externalImg.childImageSharp.gatsbyImageData}
                      alt='Picture'
                      loading='eager'
                    />
                    : null}

                  </div>



                {images && images.length && externalReportImages ?
                  <>
                  {pics && pics.length > 0 && (
                    <Grid>
                      {pics.map((image, i) => {
                        // const pic = getImage(image)
                        const pic = getImage(image)
                        // console.log(pic.layout)
                        
                        return (
                          pic ?
                          <div
                            key={i}
                            style={{
                              position: 'relative',
                              cursor: 'pointer',
                              overflow: 'hidden'
                            }}
                            role='button'
                            tabIndex={0}
                            onClick={() => {
                              setShowImageIndex(i)
                            }}
                          >
                          
                          <ImgWrapper>
                          
                            <GatsbyImage image={pic} alt={i} />
                           
                            </ImgWrapper>
                          
                          </div>
                          : null
                      
                      )
                      })}
                    </Grid>
                  )}

                  {showImageIndex !== false && (
                    <div style={{ position: 'relative' }}>
                      <Lightbox
                        hideDownload={false}
                        alt={title + '' + '_' + (showImageIndex + 1)}
                        // large={images[showImageIndex].publicURL}
                        // large={images.img[showImageIndex].publicURL}
                        large={pics[showImageIndex].publicURL}
                        onClose={() => {
                          setShowImageIndex(false)
                        }}
                      />
                      {showImageIndex >= 1 ?
                        <PrevBtn onClick={() => setShowImageIndex(showImageIndex - 1)}>
                          <img src={cursorBtn} alt='Zurück' />
                        </PrevBtn>
                        : null}
                      {showImageIndex < pics.length - 1 ?
                        <NextBtn onClick={() => setShowImageIndex(showImageIndex + 1)}>
                          <img src={cursorBtn} alt='Vorwärts' />
                        </NextBtn>
                        : null}
                    </div>
                  )}
                </>
                : null}


                  {/***********************
                  EXTERNAL IMAGES START
                  ************************/}
                {images && images.length ?
                  null
                  :
                  <>
                    {externalReportImages && externalReportImages.length > 0 && (
                      <Grid>
                        {externalReportImages.map((image, i) => {
                          // const pic = getImage(image)
                          // const pic = getImage(image)
                          // console.log(pic.layout)
                          
                          return (
                            image ?
                            <div
                              key={i}
                              style={{
                                position: 'relative',
                                cursor: 'pointer',
                                overflow: 'hidden'
                              }}
                              role='button'
                              tabIndex={0}
                              onClick={() => {
                                setShowImageIndex(i)
                              }}
                            >
                            
                            <ImgWrapper>
                            
                              <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt={i} />
                            
                              </ImgWrapper>
                            
                            </div>
                            : null
                        
                        )
                        })}
                      </Grid>
                    )}

                    {showImageIndex !== false && (
                      <div style={{ position: 'relative' }}>
                        <Lightbox
                          hideDownload={false}
                          alt={title + '' + '_' + (showImageIndex + 1)}
                          // large={images[showImageIndex].publicURL}
                          // large={images.img[showImageIndex].publicURL}
                          large={externalReportImages[showImageIndex].publicURL}
                          onClose={() => {
                            setShowImageIndex(false)
                          }}
                        />
                        {showImageIndex >= 1 ?
                          <PrevBtn onClick={() => setShowImageIndex(showImageIndex - 1)}>
                            <img src={cursorBtn} alt='Zurück' />
                          </PrevBtn>
                          : null}
                        {showImageIndex < externalReportImages.length - 1 ?
                          <NextBtn onClick={() => setShowImageIndex(showImageIndex + 1)}>
                            <img src={cursorBtn} alt='Vorwärts' />
                          </NextBtn>
                          : null}
                      </div>
                    )}
                  </>
                }
                  

                  {/***********************
                  EXTERNAL IMAGES END
                  ************************/}



                </div>

                <div className='column is-6'>
                  <Post style={{ color: 'var(--color-text)' }}>
                    <PostContent content={content} />
                  </Post>
                </div>

              </div>
                {/* <div className='column is-12' style={{ margin: '2rem auto' }}>
                  <Location>
                    {({ location }) => {
                      const domain = 'https://www.caluba.at'
                      const path = location.pathname
                      const url = domain + path
                      return (
                        <>
                          <Share title={title} url={url} />
                        </>
                      )
                    }}
                  </Location>
                </div> */}

                <div className='column is-12 has-text-right my-4'>
                  <CopyToClipboard />
                </div>

                {tags && tags.length ? (
                  <div style={{ marginTop: '4rem' }}>
                    <h4 style={{ color: 'var(--color-text)' }}>Tags</h4>
                    <div className='tags'>
                      {tags.map(tag => (
                        <span className='tag is-primary is-medium' key={tag + 'tag'}>
                          <Link style={{ color: '#fff' }} to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                        </span>
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className='column is-1' />

              {/* <div className='column is-6'>
                <BlogRollRecommended />
              </div> */}
              
            </div>
            <div className='columns' style={{ margin: '3rem auto 5rem' }}>
              <div className='column is-12 has-text-centered'>
                <Link className='button is-outlined is-primary' to='/#news'>zurück
                </Link>
              </div>
            </div>
          </div>
        </FadeIn>
        <ProgressLine style={{ width: `${progress * 100}vw` }} />
    </section>

  </>
  )
}

BlogPostTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string
}

const BlogPost = ({ data }) => {
  const { markdownRemark: post, footerData } = data

  return (
    <Layout footerData={footerData}>
    {/*<Layout navbarData={navbarData} bannerData={bannerData} footerData={footerData}>*/}
      <BlogPostTemplate
        image={post.frontmatter.image}
        externalImg={post.externalImg}
        externalReportImages={post.externalReportImages}
        images={post.frontmatter.images}
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </Layout>
  )
}

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object
  })
}

export default BlogPost

export const Head = ({data}) => {
  const { markdownRemark: post } = data
  // alert(`${post.frontmatter.title} | ${post.frontmatter.description}`)
  return(
    <Seo
      title={`${post.frontmatter.title}`}
      description={`${post.frontmatter.description}`} 
    />
  )
}

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      externalImg {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            height: 300
          )
        }
      }
      externalReportImages {
        
        publicURL
        childImageSharp {
          gatsbyImageData(
            width: 2048
            placeholder: BLURRED
          )
        }
        
      }
      frontmatter {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              placeholder: BLURRED
            )
          }
        }
        images {
          img{
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 2048
                placeholder: BLURRED
              )
            }
          }
        }
        date(formatString: "DD.MM.YYYY")
        title
        description
        tags
      }
    }
    ...LayoutFragment
  }
`

const Post = styled.div`
strong{
  color: var(--color-text);
}
`

const ProgressLine = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  height: 5px;
  background: linear-gradient(
    90deg,
    rgba(0, 103, 173, 0.4332107843137255) 0%,
    rgba(0, 103, 173, 0.6264880952380952) 52%,
    rgba(0, 103, 173, 1) 100%
  );
  transition: 1s ease;
`


const Grid = styled.div`
  marginBottom: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
  // gridTemplateColumns: 'repeat(3, 1fr)';
  grid-gap: 1rem;
`

const ImgWrapper = styled.div`
  transition: transform 0.5s, filter 0.25s;
  &:hover {
    transform: scale(1.1);
    filter: saturate(1.3);
  }
`

const PrevBtn = styled.button`
  cursor: pointer;
  background: none;
  width: 55px;
  height: 55px;
  outline: none;
  border: none;
  z-index: 23232323232;
  position: fixed;
  left: 10%;
  bottom: 12%;
`

const NextBtn = styled.button`
  cursor: pointer;
  background: none;
  width: 55px;
  height: 55px;
  outline: none;
  border: none;
  z-index: 23232323232;
  position: fixed;
  right: 10%;
  transform: rotate(180deg);
  bottom: 12%;
`
